import type {AxiosRequestConfig} from 'axios';
import {Order, Status, CancelOrder, PayloadAllUpdate} from './interface';

export class DeleteOrderBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateInventoryItemOrderItem {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/inventory-items/${id}/order-item`;
    return this;
  }

  data(data: any) {
    this.orderRequest.data = data;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class SendDelayDeliveryOrderTimeSms {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/delay`;
    return this;
  }

  data(data: any) {
    this.orderRequest.data = data;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class CancelOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/cancel`;
    return this;
  }

  data(data: CancelOrder) {
    this.orderRequest.data = data;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class DeletePostOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/post-orders`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}
export class LocateAllInventoryItemsUnitForOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: 'inventory-items/order-locate',
    data: {},
  };
  data(body: Record<string, any>) {
    this.orderRequest.data = body;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}
export class LocateInventoryItemUnitForOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.orderRequest.url = `/inventory-items/${id}/order-locate`;
    return this;
  }
  data(body: Record<string, any>) {
    this.orderRequest.data = body;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}
export class GetAllOrdersRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }

  id(id: number) {
    this.orderRequest.url = `/orders/${id}`;
    return this;
  }

  bundleId(id: number) {
    if (!this.orderRequest.params.bundleId) {
      this.orderRequest.params.bundleId = {};
    }
    this.orderRequest.params.bundleId.equals = id;
    return this;
  }

  DeliveryDateEquals(date: Date) {
    if (!this.orderRequest.params.deliveryDate) {
      this.orderRequest.params.deliveryDate = {};
    }
    this.orderRequest.params.deliveryDate.equals = date.toISOString();
    return this;
  }

  DeliveryDateGreaterThan(date: Date) {
    if (!this.orderRequest.params.deliveryDate) {
      this.orderRequest.params.deliveryDate = {};
    }
    this.orderRequest.params.deliveryDate.reaterThan = date.toISOString();
    return this;
  }

  DeliveryDateLessThan(date: Date) {
    if (!this.orderRequest.params.deliveryDate) {
      this.orderRequest.params.deliveryDate = {};
    }
    this.orderRequest.params.deliveryDate.lessThan = date.toISOString();
    return this;
  }

  DeliveryStartTimeEquals(date: Date) {
    if (!this.orderRequest.params.deliveryStartTime) {
      this.orderRequest.params.deliveryStartTime = {};
    }
    this.orderRequest.params.deliveryStartTime.equals = date.toISOString();
    return this;
  }

  DeliveryEndTimeEquals(date: Date) {
    if (!this.orderRequest.params.deliveryEndTime) {
      this.orderRequest.params.deliveryEndTime = {};
    }
    this.orderRequest.params.deliveryEndTime.equals = date.toISOString();
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetOrderFileRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/file',
    params: {},
  };

  id(id: string) {
    this.orderRequest.url = `/orders/file/${id}`;
    return this;
  }

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}

export class GetVitrinOrdersRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/vitrin',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}
export class GetIncomingOrdersRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/partner-products',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}
export class GetOrder3PLStatusRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pls/3pl-register',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}
export class GetAllOrdersPrintRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/print',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/print/`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetOrdersCountRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/count',
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetOrderPackageConfigsRequestBuilder {
  private readonly packageConfigRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partner-package-config',
    params: {},
  };

  id(id: string) {
    this.packageConfigRequest.url = `partner-package-config/order/${id}`;
    return this;
  }

  params(params: object) {
    this.packageConfigRequest.params = params;
    return this;
  }

  build() {
    return this.packageConfigRequest;
  }
}

export class GetPostOrdersCountRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/post-orders/count',
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetOrderLogsBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };

  id(id: number) {
    this.orderRequest.url = `orders/${id}/logs`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}
export class GetTPLOrderLogsBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pl-order-logs',
    params: {},
  };
  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }
  build() {
    return this.orderRequest;
  }
}

export class CreateOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/new',
    data: {},
  };

  data(data: Order) {
    this.orderRequest.data = data;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders',
    data: {},
  };

  data(body: Order) {
    this.orderRequest.data = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class NewUpdateOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders/new',
    data: {},
  };

  data(body: Order) {
    this.orderRequest.data = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateAllOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders/status',
    data: {},
  };

  data(body: PayloadAllUpdate) {
    this.orderRequest.data = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateAllOrderAssignRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders/status',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `orders/operator/${id}`;
    return this;
  }

  data(body: any) {
    this.orderRequest.data = body.ids;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateOrderStatusRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/status`;
    return this;
  }

  data(body: {status: Status; description?: string}) {
    this.orderRequest.data = {
      status: body.status,
      description: body.description ? body.description : undefined,
    };
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdatePostOrderStatusRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/post-orders/${id}/status`;
    return this;
  }

  data(body: {status: Status}) {
    this.orderRequest.data = `"${body.status}"`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateOrderDeliveryTypeRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/order-delivery-type`;
    return this;
  }

  data(body: Status) {
    this.orderRequest.data = `"${body}"`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class AddOrderDimensionsRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/orders/${id}/order-packages`;
    return this;
  }

  data(body: Status) {
    this.orderRequest.data = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class CreatePostOrderRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/post-orders/send',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/post-orders`;
    return this;
  }

  send(id: number) {
    this.orderRequest.url = `/post-orders/${id}/send`;
    return this;
  }

  data(body: Status) {
    this.orderRequest.data = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetPostOrdersRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/post-orders',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/post-orders/${id}`;
    return this;
  }

  params(body: any) {
    this.orderRequest.params = body;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class UpdateOrderItemStatusRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.orderRequest.url = `/order-items/${id}/status`;
    return this;
  }

  data(body: Status) {
    this.orderRequest.data = `"${body}"`;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class GetAllOrdersReportRequestBuilder {
  private readonly orderRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/report',
    params: {},
  };

  params(params: object) {
    this.orderRequest.params = params;
    return this;
  }

  build() {
    return this.orderRequest;
  }
}

export class AssignOrderRequestBuilder {
  private readonly assignRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.assignRequest.url = `/orders/${id}/operator`;
    return this;
  }

  data(body: Status) {
    this.assignRequest.data = `"${body}"`;
    return this;
  }

  build() {
    return this.assignRequest;
  }
}

export class UpdateBundleOrdersRuequestBuilder {
  private readonly assignRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.assignRequest.url = `/bundles/${id}/priority`;
    return this;
  }

  data(body: object) {
    this.assignRequest.data = body;
    return this;
  }

  build() {
    return this.assignRequest;
  }
}

export class UpdateOrderPostTrackingCode {
  private readonly updateTrackingCodeReq: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.updateTrackingCodeReq.url = `/orders/${id}/post-tracking-code`;
    return this;
  }

  data(body: object) {
    this.updateTrackingCodeReq.data = `${body}`;
    return this;
  }

  build() {
    return this.updateTrackingCodeReq;
  }
}
export class UpdateOrderDeliveryCost {
  private readonly updateTrackingCodeReq: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.updateTrackingCodeReq.url = `/orders/${id}/delivery-cost`;
    return this;
  }

  data(body: number | undefined) {
    this.updateTrackingCodeReq.data = `${body}`;
    return this;
  }

  build() {
    return this.updateTrackingCodeReq;
  }
}

export class ChangeOrderDeliveryTypeRequestBuilder {
  private readonly assignRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '',
    data: {},
  };

  id(id: number) {
    this.assignRequest.url = `/orders/${id}/order-delivery-type`;
    return this;
  }

  data(body: object) {
    this.assignRequest.data = `"${body}"`;
    return this;
  }

  build() {
    return this.assignRequest;
  }
}

export class GetAllOrderItemsRequestBuilder {
  private readonly orderItemsRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/order-items',
    params: {},
  };

  params(params: object) {
    this.orderItemsRequest.params = params;
    return this;
  }

  id(id: number) {
    this.orderItemsRequest.url = `/order-items/${id}`;
    return this;
  }

  build() {
    return this.orderItemsRequest;
  }
}

export class DeleteOrderItemRequestBuilder {
  private readonly removeOrderRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/order-items',
    params: {},
  };

  id(id: number) {
    this.removeOrderRequest.url = `/order-items/${id}`;
    return this;
  }

  build() {
    return this.removeOrderRequest;
  }
}

export class CreateOrderItemsRequestBuilder {
  private readonly createOrderItemReq: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders',
    data: {},
  };

  id(id: number) {
    this.createOrderItemReq.url = `/orders/${id}/items`;
    return this;
  }

  data(body: any) {
    this.createOrderItemReq.data = body;
    return this;
  }

  build() {
    return this.createOrderItemReq;
  }
}

export class UploadOrdersRequestBuilder {
  private readonly uploadOrdersReq: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/uploadFile',
    data: {},
    params: {},
  };

  id(type: string) {
    this.uploadOrdersReq.url = `/orders/uploadFile/${type}`;
    return this;
  }

  params(params: object) {
    this.uploadOrdersReq.params = params;
    return this;
  }

  data(body: any) {
    this.uploadOrdersReq.data = body;
    return this;
  }

  build() {
    return this.uploadOrdersReq;
  }
}

export class UploadOrdersStatusRequestBuilder {
  private readonly uploadOrdersReq: AxiosRequestConfig = {
    method: 'PUT',
    url: '/orders/status/uploadFile',
    data: {},
    params: {},
  };

  params(params: object) {
    this.uploadOrdersReq.params = params;
    return this;
  }

  data(body: any) {
    this.uploadOrdersReq.data = body;
    return this;
  }

  build() {
    return this.uploadOrdersReq;
  }
}
export class Upload3PLRequestBuilder {
  private readonly uploadOrdersReq: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/3pl/uploadFile',
    data: {},
  };

  data(body: any) {
    this.uploadOrdersReq.data = body;
    return this;
  }

  build() {
    return this.uploadOrdersReq;
  }
}

export class GetPickListRequestBuilder {
  private readonly picklistReq: AxiosRequestConfig = {
    method: 'GET',
    url: '/orders/pick-list',
  };

  params(params: object) {
    this.picklistReq.params = params;
    return this;
  }

  build() {
    return this.picklistReq;
  }
}

export class SetOrders3PLRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/3pl',
    data: {},
  };

  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class GetOrder3PLsRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pl-orders',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/3pl-orders/${id}`;
    return this;
  }

  params(params: object) {
    this.ordersTpl.params = params;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class GetOrderTapinsRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pls/labels',
    data: {},
  };

  id(ids: string) {
    this.ordersTpl.url = `/3pls/labels?tplCode=TAPIN_POST&orderIds=${ids}`;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class GetOrderTapinsKetabRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pls/labels',
    data: {},
  };

  id(ids: string) {
    this.ordersTpl.url = `/3pls/labels?tplCode=TAPIN_KETAB&orderIds=${ids}`;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class GetOrderTapinsBarcodeRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pls/barcodes',
    data: {},
  };

  id(ids: string) {
    this.ordersTpl.url = `/3pls/barcodes?orderIds=${ids}&size=1000`;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class UpdateOrder3PLsRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'PUT',
    url: '/3pl-orders',
    data: {},
  };

  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class CreateRequestOrder3PLsRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '/3pl-orders',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/3pl-orders/${id}/register`;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class Get3PLsRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/3pls',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/3pls/${id}`;
    return this;
  }

  params(params: object) {
    this.ordersTpl.params = params;
    return this;
  }

  data(data: any) {
    this.ordersTpl.data = data;
    return this;
  }

  build() {
    return this.ordersTpl;
  }
}

export class Cancel3PLItemRequestBuilder {
  private readonly parcelRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/',
    data: {},
  };
  id(id: number) {
    this.parcelRequest.url = `/3pl-orders/${id}/cancel`;
    return this;
  }
  data(body: Record<string, any>) {
    this.parcelRequest.data = body;
    return this;
  }
  build() {
    return this.parcelRequest;
  }
}
export class GetOrderPackageRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'GET',
    url: '/order-packages',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/order-packages/${id}`;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class CreateOrderPackageRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '/order-packages',
    data: {},
  };

  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class SetOrderPackageConsumablesRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/order-packages/${id}/consumables`;
    return this;
  }
  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class SetOrderPackageInventoryItemRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/order-packages/${id}/inventory-items`;
    return this;
  }
  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class RemoveOrderPackageInventoryItemRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
    data: {},
  };

  id(id: number) {
    this.ordersTpl.url = `/order-packages/${id}/inventory-items`;
    return this;
  }
  data(data: object) {
    this.ordersTpl.data = data;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class RemoveOrderPackageRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };

  id(id: number) {
    this.ordersTpl.url = `/order-packages/${id}`;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class SetOrderPackagedRequestBuilder {
  private readonly ordersTpl: AxiosRequestConfig = {
    method: 'POST',
    url: '',
  };

  id(id: number) {
    this.ordersTpl.url = `/orders/${id}/packaged`;
    return this;
  }
  build() {
    return this.ordersTpl;
  }
}
export class ResendOrdersRequestBuilder {
  private readonly ordersResend: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/resend',
    data: {},
  };
  data(data: object) {
    this.ordersResend.data = data;
    return this;
  }
  build() {
    return this.ordersResend;
  }
}
export class GetSuggestedCourierAssignmentList {
  private readonly ordersResend: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/3pl/suggest',
    data: {},
    params: {},
  };
  params(params: any) {
    this.ordersResend.params = params;
    return this;
  }
  data(data: object) {
    this.ordersResend.data = data;
    return this;
  }
  build() {
    return this.ordersResend;
  }
}
export class ValidateOrdersBeforeCreateTpl {
  private readonly ordersResend: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/3pl/manual',
    data: {},
  };
  data(data: object) {
    this.ordersResend.data = data;
    return this;
  }
  build() {
    return this.ordersResend;
  }
}

export class CreateBatchTpl {
  private readonly ordersResend: AxiosRequestConfig = {
    method: 'POST',
    url: '/orders/3pl/batch',
    data: {},
  };
  data(data: object) {
    this.ordersResend.data = data;
    return this;
  }
  build() {
    return this.ordersResend;
  }
}
